let lastSession
let videoUrl
let screenshot
let domEvents

export async function getDomEvents(session) {
	if (session.id !== lastSession?.id) resetSessionData()
	lastSession = session

	if (!domEvents && session.domEvents) {
		domEvents = await fetch(session.domEvents).then(res => res.json())
	}
	return {domEvents}
}

export async function getVideo(session) {
	if (session.id !== lastSession?.id) resetSessionData()
	lastSession = session

	if (!videoUrl && session.video) {
		videoUrl = session.video
	}
	return {videoUrl}
}

export async function getScreenshot(session) {
	if (session.id !== lastSession?.id) resetSessionData()
	lastSession = session

	if (!screenshot && session.screenshot) {
		screenshot = session.screenshot
	}
	return {screenshot}
}

function resetSessionData() {
	domEvents = null
	videoUrl = null
	screenshot = null
}

export default {
	getDomEvents,
	getVideo,
	getScreenshot,
}
